import { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { Link } from '@/components/link/link';
import { config } from '@/config/environment';
import { sanityClient } from '@/content/sanity/sanity-client/sanity-client';
import { PortableText } from '@portabletext/react';

const MainDiv = styled.div`
  height: auto;
  width: 100%;
  padding: 13% 12.5% calc(10.51% - 32px) 12.5%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  background: ${({ theme }) => theme.palette.common.midnight};
  @media (max-width: 768px) {
    padding: 98px 20px;
    min-height: 100vh;
  }
`;
const Title = styled(Typography)`
  font-family: var(--font-cooper-light);
  font-style: normal;
  font-weight: 300;
  font-size: 50px;
  line-height: 109.3%;
  color: #ffffff;
  margin-bottom: 60px;
`;
const Text = styled(Typography)`
  font-family: var(--font-work-sans);
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 160%;
  color: #ffffff;
  margin-bottom: 32px;
  & a {
    color: #4497aa;
    text-decoration: none;
  }
`;

interface PartnerWithUsDocument {
  _id: string;
  _type: 'partnerWithUs';
  title: string;
  description: any[];
}

const BecomePartners = () => {
  const [content, setContent] = useState<PartnerWithUsDocument | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const archiveMode = config.platformMode === 'archive';

  useEffect(() => {
    const fetchContent = async () => {
      const data = await sanityClient.fetch(
        `*[_type=="partnerWithUs"][0]{ _id, title, description }`,
      );
      setContent(data);
      setLoading(false);
    };

    fetchContent();
  }, []);

  if (loading || !content) {
    return <MainDiv>Loading...</MainDiv>;
  }

  return (
    <MainDiv>
      <Title>{content.title}</Title>
      {archiveMode ? (
        <>
          <Text>
            While the Curiko platform is no longer active, InWithForward—the social design team
            behind it—continues to explore how we can create more welcoming communities, reduce
            stigma, and support flourishing lives.
          </Text>
          <Text>
            If you’re part of a government agency, nonprofit, philanthropic organization, or are
            simply curious about how Curiko’s values might live on in the world, we’d love to hear
            from you.
          </Text>
          <Text>Connect with us at info@inwithforward.com</Text>
        </>
      ) : (
        <Text>
          <PortableText
            value={content.description}
            components={{
              marks: {
                link: ({ children, value }: any) => <Link href={value.href}>{children}</Link>,
                strong: ({ children }: any) => <strong>{children}</strong>,
              },
              block: {
                normal: ({ children }: any) => <p>{children}</p>,
              },
            }}
          />
        </Text>
      )}
    </MainDiv>
  );
};

export default BecomePartners;
